<div class="search-input">
    <div class="search-container">
        <div class="search">
        </div>
    </div>
    <input placeholder="Rechercher" (ngModelChange)="searchSubject.next()" [(ngModel)]="searchInput" [ngModelOptions]="{ standalone: true }" (focus)="selectAll($event)"/>
  </div>
